import React from "react";

import {
  BackHandler,
  Image,
  ScrollView,
  Text,
  TouchableOpacity,
  View
} from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

import { getBaseUrl } from "../helpers/storage";
import moment from "moment";

class PostAssessmentScreen extends React.Component {
  componentDidMount() {
    this.backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      this.handleBackPress
    );
  }

  componentWillUnmount() {
    this.backHandler.remove();
  }

  handleBackPress = () => {
    return true;
  };

  async submit(result) {
    const { token } = this.props;

    await fetch(getBaseUrl() + "consultations/post-assessment", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify({
        result: result
      })
    });

    this.props.navigation.goBack();
  }

  render() {
    const { themeColors } = this.props;
    const { transaction } = this.props.navigation.state.params;

    const time = moment(transaction.startedAt).format(
      "DD MMMM YYYY [pukul] H:m "
    );

    return (
      <View style={{ backgroundColor: themeColors.primary, flex: 1 }}>
        <ScrollView style={{ flexGrow: 1 }}>
          <View>
            <Text
              style={{
                color: staticColors.white,
                fontSize: 24,
                padding: 20,
                textAlign: "center",

                ...fonts.bold
              }}
            >
              {transaction.doctor.fullName}
            </Text>
            <View
              style={{
                backgroundColor: staticColors.white
              }}
            >
              <Image
                source={{
                  uri: transaction.doctor.avatarUrl
                }}
                style={{
                  alignSelf: "center",
                  borderColor: "rgba(255, 255, 255, 0.5)",
                  borderRadius: 90,
                  borderWidth: 10,
                  height: 180,
                  marginVertical: 20,
                  width: 180
                }}
              />
            </View>
          </View>
          <View style={{ padding: 20 }}>
            <Text
              style={{
                color: staticColors.white,
                fontSize: 16,

                ...fonts.bold
              }}
            >
              Summary Konsultasi
            </Text>
            <Text
              style={{
                color: staticColors.white,
                fontSize: 16,

                ...fonts.regular
              }}
            >
              {transaction.summary}
            </Text>
          </View>
        </ScrollView>
        <View
          style={{
            backgroundColor: staticColors.white,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40,
            padding: 25
          }}
        >
          <Text
            style={{
              color: staticColors.cavernous,
              fontSize: 24,
              marginBottom: 15,
              textAlign: "center",

              ...fonts.bold
            }}
          >
            Survey Singkat
          </Text>
          <Text
            style={{
              color: staticColors.grey,
              fontSize: 16,
              marginBottom: 30,
              textAlign: "center",

              ...fonts.regular
            }}
          >
            Setelah konsultasi dengan {transaction.doctor.fullName} pada {time}
            apakah Anda jadi rawat jalan ke rumah sakit/klinik?
          </Text>
          <View
            style={{ flexDirection: "row", justifyContent: "space-around" }}
          >
            <TouchableOpacity
              onPress={() => this.submit(false)}
              style={{
                backgroundColor: staticColors.thimbleberry,
                borderRadius: 20,
                paddingHorizontal: 30,
                paddingVertical: 10
              }}
            >
              <Text
                style={{
                  color: staticColors.white,
                  fontSize: 16,

                  ...fonts.bold
                }}
              >
                Tidak
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => this.submit(true)}
              style={{
                backgroundColor: staticColors.forestFern,
                borderRadius: 20,
                paddingHorizontal: 30,
                paddingVertical: 10
              }}
            >
              <Text
                style={{
                  color: staticColors.white,
                  fontSize: 16,

                  ...fonts.bold
                }}
              >
                Ya
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(PostAssessmentScreen);
